import { type LinksFunction } from '@remix-run/node';

import {
  SharedAnchor,
  links as sharedAnchorLinks,
} from '@/components/shared/shared-anchor/shared-anchor';

import { INSURANCE_SUMMARY_OF_BENEFITS_URL } from '@/constants/urls';

import styles from './shared-disclaimer.css?url';

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: styles },
  ...sharedAnchorLinks(),
];

export const SharedDisclaimer = () => {
  return (
    <div className="shared-disclaimer">
      <p>
        * The Identity Theft Insurance is underwritten and administered by
        American Bankers Insurance Company of Florida, an Assurant company.
        Please refer to the actual policies for terms, conditions, and
        exclusions of coverage. Coverage may not be available in all
        jurisdictions. Review the{' '}
        <SharedAnchor href={INSURANCE_SUMMARY_OF_BENEFITS_URL} isNewTab>
          Summary of Benefits
        </SharedAnchor>
        .
      </p>

      <p>
        ** The introductory price is valid for the first term of your
        subscription. At the end of the expiration of the initial term, you will
        be automatically renewed at the renewal price. This price is subject to
        change. We will always notify you by email in advance prior to renewal.
      </p>

      <p>
        <sup className="shared-disclaimer__sup">2</sup> 60-day money back
        guarantee is only available for our annual plans purchased through our
        websites or via our Customer Support team. You may cancel your
        membership online and request a refund within 60 days of your initial
        purchase date of an eligible Aura membership purchase either through
        your Aura Account Membership portal or by calling us at{' '}
        <SharedAnchor href="tel:18335522123" isNewTab>
          1-833-552-2123
        </SharedAnchor>
        . If you signed up for Aura through a free trial, then your membership
        purchase date will be the date you signed up for your free trial, and
        you will have 60 days from the date you signed up for your free trial to
        cancel and request a refund. If you switched to a new annual plan within
        60 days of your initial Aura annual subscription, you may still qualify
        for the Money Back Guarantee (based upon your initial annual plan
        purchase date).
      </p>

      <p>
        <sup className="shared-disclaimer__sup">3</sup> As compared to the
        competition. Results based on a 2022 mystery shopper consumer study
        conducted by ath Power Consulting. ath Power Consulting was compensated
        by Aura to conduct this study.
      </p>

      <p>
        No one can prevent all identity theft or monitor all transactions
        effectively. Further, any testimonials on this website reflect
        experiences that are personal to those particular users, and may not
        necessarily be representative of all users of our products and/or
        services. We do not claim, and you should not assume, that all users
        will have the same experiences. Your individual results may vary.
      </p>
    </div>
  );
};
